import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import { initUsercentricsConsent } from "./utils/initUsercentrics";

const RootWithConsent = () => {
  useEffect(() => {
    initUsercentricsConsent();
  }, []);

  return (
    <StrictMode>
      <HelmetProvider>
          <App />
      </HelmetProvider>
    </StrictMode>
  );
};

createRoot(document.getElementById("root")!).render(<RootWithConsent />);